var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.387,
    height: 65.387,
    viewBox: "0 0 17.3 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-13.542-10.978-24.52-24.52-24.52S-49.04-13.542-49.04 0s10.978 24.52 24.52 24.52S0 13.542 0 0",
    style: {
      fill: "#00c0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 17.3 8.65)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.019-.609 2.042-1.213 3.056-1.831.563-.344.714-.935.394-1.516-.512-.926-1.031-1.85-1.558-2.769-.33-.576-.968-.758-1.496-.447-.514.301-.669.928-.368 1.496.094.177.196.35.341.609-.204-.068-.334-.104-.456-.155-5.237-2.221-8.398-6.122-9.199-11.758-.976-6.861 3.013-13.355 9.521-15.725.778-.283 1.598-.455 2.407-.649.705-.169 1.097-.705.937-1.35-.139-.56-.682-.891-1.304-.774-3.789.714-7.005 2.474-9.568 5.359-3.009 3.386-4.412 7.377-4.274 11.896.204 6.691 4.651 12.795 10.966 15.102.107.039.212.083.376.148-.468.329-1.014.516-1.098 1.14-.071.527.172.908.823 1.224z",
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 6.81 2.196)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.496.535 2.789 1.212 3.949 2.118 4.025 3.143 5.995 7.289 5.844 12.383-.201 6.76-5.344 12.629-11.997 13.797-.63.111-1.006.489-1.038 1.046-.027.462.288.925.753 1.051.189.05.405.059.598.025 7.046-1.232 12.557-6.898 13.644-14.02A16.823 16.823 0 0 0 .964-1.935l-.375-.141.539-.338c.564-.358.742-.982.43-1.507-.31-.521-.957-.669-1.527-.33-.91.541-1.818 1.088-2.719 1.644-.547.336-.707.928-.399 1.486.516.938 1.042 1.872 1.574 2.801.324.563.94.745 1.468.453.523-.287.697-.92.405-1.485C.263.459.154.276 0 0",
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 10.36 13.54)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-.739-.274-1.014-1.011-1.014h-10.143c-.742 0-1.014.272-1.015 1.009v6.394c.001.7.273.972.974.973 1.703.002 3.405 0 5.108 0 1.691 0 3.381.002 5.072 0C-.263 7.361 0 7.102 0 6.357V0m-8.62 13.751c1.487 1.039 3.096 1.134 4.679.245 1.709-.959 2.38-2.508 2.276-4.471h-8.831c-.126 1.759.427 3.214 1.876 4.226M.702 9.11c-.109.073-.196.251-.208.388-.047.545-.015 1.1-.093 1.639-.408 2.791-2.639 5.04-5.421 5.494a6.594 6.594 0 0 1-6.863-3.408c-.617-1.159-.823-2.4-.768-3.695.009-.213-.054-.335-.244-.454-.928-.581-1.411-1.428-1.414-2.527-.006-2.204-.005-4.408-.002-6.612.003-1.845 1.254-3.09 3.1-3.093 1.703-.002 3.407 0 5.11 0 1.728 0 3.455-.003 5.183.001 1.797.003 3.054 1.258 3.059 3.059.005 2.193 0 4.384.002 6.577.001 1.142-.488 2.007-1.441 2.631",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 10.797 10.866)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .25-.01.501.002.751A1.076 1.076 0 0 0 1.066 1.79 1.065 1.065 0 0 0 2.136.759c.019-.523.02-1.048-.001-1.571A1.078 1.078 0 0 0 1.057-1.84 1.09 1.09 0 0 0 .002-.786C-.009-.524 0-.262 0 0",
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 -.35278 8.273 9.738)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change_password.0d349021137cbd26d78acf1a46d2e872.svg";
export { ForwardRef as ReactComponent };